import React, { useState } from 'react';
import { translate } from '../../Services/translation';
import { string, object } from 'yup';
import { post } from '../../Services/http';

const formschema = object().shape({
    subject: string().required(translate(`validation.required`)),
    email: string()
        .required(translate(`validation.required`))
        .email(translate(`validation.emailInvalid`)),
});

export const ContactUsBlock = ({ model }) => {

    const initialValues = {
        subject: '',
        name: '',
        email: '',
        phone: '',
        msg: '',
        recipientEmail: model.RecipientEmail,
    };

    const [form, setForm] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState(null);

    const onChange = (propName, value) => {
        setForm((prevState) => ({
            ...prevState,
            [propName]: value,
        }));
    };

    const onSubmit = async () => {
        
        try {
            await formschema.validate(form, { abortEarly: false });
            setErrors({});
            const res = await post('/api/contactusmail', form);

            if (res.status < 300 && res.status > 199) {
                setMessage(translate('contactus.block.success'));
                setForm(initialValues);
            } else {
                setMessage(translate('contactus.block.failed'));
            }
        } catch (error) {
            const validationErrors = {};
            error.inner.forEach((e) => {
                validationErrors[e.path] = e.message;
            });
            setErrors(validationErrors);
        }
    };

    return (
        <div className="contactusblock-container-right-container-content">
            <form className="contactusblock-container-right-container-form" onSubmit={(e) => e.preventDefault()}>
                <div className="contactusblock-container-right-container-content-rowform">
                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input1">
                            {translate('contactus.block.subject')} *
                            {errors.subject && <span className="contactusblock-container-right-container-content-form-error-message">{errors.subject}</span>}
                        </label>
                        <input
                            className={`contactusblock-container-right-container-content-form-input ${errors.subject ? 'input-error' : ''
                                }`}
                            type="text"
                            value={form.subject}
                            id="input1"
                            name="input1"
                            onChange={(event) => onChange('subject', event.target.value)}
                        />
                    </div>

                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input2">
                            {translate('contactus.block.name')}
                        </label>
                        <input
                            className="contactusblock-container-right-container-content-form-input"
                            type="text"
                            value={form.name}
                            id="input2"
                            name="input2"
                            onChange={(event) => onChange('name', event.target.value)}
                        />
                    </div>
                </div>
                <div className="contactusblock-container-right-container-content-rowform">
                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input3">
                            {translate('contactus.block.email')} *
                            {errors.email && <span className="contactusblock-container-right-container-content-form-error-message">{errors.email}</span>}
                        </label>
                        <input
                            className={`contactusblock-container-right-container-content-form-input ${errors.email ? 'input-error' : ''
                                }`}
                            type="text"
                            value={form.email}
                            id="input3"
                            name="input3"
                            onChange={(event) => onChange('email', event.target.value)}
                        />
                    </div>

                    <div className="contactusblock-container-right-container-content-form">
                        <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input4">
                            {translate('contactus.block.phone')}
                        </label>
                        <input
                            className="contactusblock-container-right-container-content-form-input"
                            type="text"
                            id="input4"
                            name="input4"
                            value={form.phone}
                            onChange={(event) => onChange('phone', event.target.value)}
                        />
                    </div>
                </div>
                <div className="contactusblock-container-right-container-content-form">
                    <label className="contactusblock-container-right-container-content-form-lable" htmlFor="input5">
                        {translate('contactus.block.msg')}
                    </label>
                    <textarea
                        className="contactusblock-container-right-container-content-form-input-big"
                        type="textarea"
                        rows="5"
                        value={form.msg}
                        id="input5"
                        name="input5"
                        onChange={(event) => onChange('msg', event.target.value)}
                    />
                </div>
                {
                    model.UnderFormText != null && (
                        <div className="contactusblock-container-right-container-content-description"

                            dangerouslySetInnerHTML={{
                                __html: model.UnderFormText,
                            }}>
                        </div>
                        )
                }
                <button className="contactusblock-container-right-container-content-form-button" type="submit" onClick={() => onSubmit()}>
                    <p> {model.ButtonText == null ? "" : model.ButtonText } </p>
                </button>

                {message && (
                    <p>{message}</p>
                )}
            </form>
        </div>
    );
};